import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components
import CoverageAccordion from './CoverageAccordion/CoverageAccordion';
import AssociationAlert from './AssociationAlert';
import AffiliationListing from '../common/AffiliationListing/AffiliationListing';
import { InboxContextProvider } from '@contexts/InboxContext';
import { Cards } from 'app-components';

// Actions
import { fetchDashboardModelsLiteStart, fetchPartnerBrokerStart } from '@actions/dashboardLite/dashboardLiteActionCreators';

//Constants
import { InboxNoticesStyled } from './GeorgiaAccessDashboardContainer.styles';

// styles

import {
    AgentName,
    AgencyName,
    Location,
    ContactPhoneEmail,
    WebsiteLink,
} from '../common/AgentCards/AgentCard.styles';

//Selectors
import { environmentSelector } from '@selectors/commonSelectors';
import { selectIsLoadingPartnerBroker, selectPartner, selectBroker } from '@selectors/dashboardLiteSelectors';

// Helpers
import { getAssociationAlertData } from '@utils/miscellaneous/getAssosicatioinAlertData';

const GeorgiaAccessDashboardContainer = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchDashboardModelsLiteStart());
    }, []);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchPartnerBrokerStart());
    }, []);

    // Needed fot Notices component (Reused)
    const [emailShown, setEmailShown] = useState(null);

    const {
        user: {
            firstName,
            lastName,
            nameSuffix
        }
    } = useSelector(environmentSelector);

    const isLoading = useSelector(selectIsLoadingPartnerBroker);
    const partner = useSelector(selectPartner);
    const broker = useSelector(selectBroker);

    const userName = nameSuffix ?
        `${firstName} ${lastName} ${nameSuffix}` :
        `${firstName} ${lastName}`;

    const ASSOCIATION_ALERT_TYPE = useMemo(() => getAssociationAlertData(partner, broker), [broker, partner]);

    const AgentCards = () => {
        return (
            <Cards numColumns={4}>
                {
                    [broker].map((item) => (
                        <Cards.Row key={item.brokerId}>
                            <Cards.Col>
                                <div className={'carriers_logo'}>
                                    <img src={item.profilePhotoUrl} alt={item.contactNumber}/>
                                </div>
                            </Cards.Col>
                            <Cards.Col>
                                <div className={'carriers_details'}>
                                    <AgentName>{item.firstName} {item.lastName}</AgentName>
                                    <AgencyName>{item.businessName}</AgencyName>
                                    <Location>{item.address1} {item.city} {item.state} {item.zip}</Location>
                                    <ContactPhoneEmail>{item.contactNumber} {item.emailAddress}</ContactPhoneEmail>
                                    <WebsiteLink href={item.websiteUrl}>{item.websiteUrl}</WebsiteLink>
                                </div>
                            </Cards.Col>
                            <Cards.Col>
                                <div className={'carriers_contact'}>
                                    <div>{item.languagesSpoken}</div>
                                </div>
                            </Cards.Col>
                            <Cards.Col>
                                <div>{item.productExpertise}</div>
                            </Cards.Col>
                        </Cards.Row>
                    ))
                }
            </Cards>
        );
    };

    if (isLoading) {
        return null;
    }

    return (
        <main className="usa-layout-docs usa-section gi-main-section" id="individual-portal">
            <div className="grid-container gi-grid-container">
                <div className={'grid-row grid-gap gi-wrapper dashboard--lite'}>
                    <h1>
                        <FormattedMessage id="welcome_user" values={{ userName }}/>
                    </h1>

                    {/*Enrollments Info per each applicationYear*/}
                    <CoverageAccordion />

                    {/*Alert*/}
                    <AssociationAlert {...{ ...ASSOCIATION_ALERT_TYPE }}/>

                    {/*Partner or Carrier*/}
                    { partner && !broker &&
                        <div className={'grid-col-12'}>
                            <AffiliationListing listingData={[partner]} />
                        </div>
                    }

                    {/*Agent (Broker)*/}
                    { broker &&
                        <AgentCards />
                    }

                    {/*Notices (Inbox)*/}
                    <InboxContextProvider>
                        <InboxNoticesStyled isLiteFormat={true} {...{ emailShown, setEmailShown }}/>
                    </InboxContextProvider>

                </div>
            </div>
        </main>
    );
};

export default GeorgiaAccessDashboardContainer;